module.exports = __webpack_public_path__ + "img/hngrow.aae905d0.jpg";